import * as localTranslations from "./translations.json";
import * as remoteTranslations from "./remote.json";

export const translations = {
  ...localTranslations,
  ...remoteTranslations,
};



// WEBPACK FOOTER //
// ./src/locales/es/index.js